import {Work} from "./domain/pages/work";
import {About} from "./domain/pages/about";

export const paths = [
    {title: 'Work',  path: '/work' , component: Work },
    {title: 'About', path: '/about', component: About},
]